import Approach from 'components/Builder/Approach/Approach';
import Book from 'components/Builder/Book/Book';
import ConnectForm1 from 'components/Builder/ConnectForm1/ConnectForm1';
import ConnectForm2 from 'components/Builder/ConnectForm2/ConnectForm2';
import Contact from 'components/Builder/Contact/Contact';
import Content10 from 'components/Builder/Content10/Content10';
import Content11 from 'components/Builder/Content11/Content11';
import Content12 from 'components/Builder/Content12/Content12';
import Content13 from 'components/Builder/Content13/Content13';
import Content14 from 'components/Builder/Content14/Content14';
import Content15 from 'components/Builder/Content15/Content15';
import Content16 from 'components/Builder/Content16/Content16';
import Content17 from 'components/Builder/Content17/Content17';
import Content18 from 'components/Builder/Content18/Content18';
import Content19 from 'components/Builder/Content19/Content19';
import Content2 from 'components/Builder/Content2/Content2';
import Content21 from 'components/Builder/Content21/Content21';
import Content22 from 'components/Builder/Content22/Content22';
import Content3 from 'components/Builder/Content3/Content3';
import Content4 from 'components/Builder/Content4/Content4';
import Content5 from 'components/Builder/Content5/Content5';
import Content6 from 'components/Builder/Content6/Content6';
import Content7 from 'components/Builder/Content7/Content7';
import Content8 from 'components/Builder/Content8/Content8';
import Content9 from 'components/Builder/Content9/Content9';
import ContentBlocks1 from 'components/Builder/ContentBlocks1/ContentBlocks1';
import ContentBlocks10 from 'components/Builder/ContentBlocks10/ContentBlocks10';
import ContentBlocks2 from 'components/Builder/ContentBlocks2/ContentBlocks2';
import ContentBlocks3 from 'components/Builder/ContentBlocks3/ContentBlocks3';
import ContentBlocks4 from 'components/Builder/ContentBlocks4/ContentBlocks4';
import ContentBlocks5 from 'components/Builder/ContentBlocks5/ContentBlocks5';
import ContentBlocks6 from 'components/Builder/ContentBlocks6/ContentBlocks6';
import ContentBlocks7 from 'components/Builder/ContentBlocks7/ContentBlocks7';
import ContentBlocks8 from 'components/Builder/ContentBlocks8/ContentBlocks8';
import ContentBlocks9 from 'components/Builder/ContentBlocks9/ContentBlocks9';
import ContentCards1 from 'components/Builder/ContentCards1/ContentCards1';
import ContentCards2 from 'components/Builder/ContentCards2/ContentCards2';
import ContentCards3 from 'components/Builder/ContentCards3/ContentCards3';
import ContentCards4 from 'components/Builder/ContentCards4/ContentCards4';
import ContentCards5 from 'components/Builder/ContentCards5/ContentCards5';
import ContentCards6 from 'components/Builder/ContentCards6/ContentCards6';
import ContentList1 from 'components/Builder/ContentList1/ContentList1';
import ContentList2 from 'components/Builder/ContentList2/ContentList2';
import ContentList3 from 'components/Builder/ContentList3/ContentList3';
import ContentList4 from 'components/Builder/ContentList4/ContentList4';
import ContentList5 from 'components/Builder/ContentList5/ContentList5';
import ContentList6 from 'components/Builder/ContentList6/ContentList6';
import Directors from 'components/Builder/Directors/Directors';
import Donation1 from 'components/Builder/Donation1/Donation1';
import Donation2 from 'components/Builder/Donation2/Donation2';
import Donation3 from 'components/Builder/Donation3/Donation3';
import Donation4 from 'components/Builder/Donation4/Donation4';
import DonationForm from 'components/Builder/DonationForm/DonationForm';
import DonorsList from 'components/Builder/DonorsList/DonorsList';
import Events from 'components/Builder/Events/Events';
import ExecutiveTeam from 'components/Builder/ExecutiveTeam/ExecutiveTeam';
import Faq from 'components/Builder/Faq/Faq';
import Header from 'components/Builder/Header/Header';
import Hero1 from 'components/Builder/Hero1/Hero1';
import Hero2 from 'components/Builder/Hero2/Hero2';
import Hero3 from 'components/Builder/Hero3/Hero3';
import HeroThanks from 'components/Builder/HeroThanks/HeroThanks';
import Highlight1 from 'components/Builder/Highlight1/Highlight1';
import Highlight2 from 'components/Builder/Highlight2/Highlight2';
import Highlight3 from 'components/Builder/Highlight3/Highlight3';
import Highlight4 from 'components/Builder/Highlight4/Highlight4';
import Highlight5 from 'components/Builder/Highlight5/Highlight5';
import Highlight6 from 'components/Builder/Highlight6/Highlight6';
import Imagine from 'components/Builder/Imagine/Imagine';
import Map from 'components/Builder/Map/Map';
import MoreHighlight from 'components/Builder/MoreHighlight/MoreHighlight';
import NewsWidget from 'components/Builder/NewsWidget/NewsWidget';
import Page_Acfbuilder_Wrapper_Content1 from 'components/Builder/Page_Acfbuilder_Wrapper_Content1/Page_Acfbuilder_Wrapper_Content1';
import Page_Acfbuilder_Wrapper_Content20 from 'components/Builder/Page_Acfbuilder_Wrapper_Content20/Page_Acfbuilder_Wrapper_Content20';
import Page_Acfbuilder_Wrapper_HeroHome from 'components/Builder/Page_Acfbuilder_Wrapper_HeroHome/Page_Acfbuilder_Wrapper_HeroHome';
import PartnersLogos from 'components/Builder/PartnersLogos/PartnersLogos';
import Positions from 'components/Builder/Positions/Positions';
import Reports from 'components/Builder/Reports/Reports';
import Slider1 from 'components/Builder/Slider1/Slider1';
import Slider2 from 'components/Builder/Slider2/Slider2';
import Slider3 from 'components/Builder/Slider3/Slider3';
import Slider4 from 'components/Builder/Slider4/Slider4';
import Slider5 from 'components/Builder/Slider5/Slider5';
import StaffTeam from 'components/Builder/StaffTeam/StaffTeam';
import ThankYou from 'components/Builder/ThankYou/ThankYou';
import Topics from 'components/Builder/Topics/Topics';
import Video1 from 'components/Builder/Video1/Video1';
import Video2 from 'components/Builder/Video2/Video2';
import Video3 from 'components/Builder/Video3/Video3';
import Video4 from 'components/Builder/Video4/Video4';
import Layout from 'components/Layout';
import Seo from 'components/Seo';
import { graphql } from 'gatsby';
import React from 'react';

import '@css/about-us-css.css';
import '@css/bg-col-css.css';
import '@css/blog-css.css';
import '@css/breadcrumbs.css';
import '@css/care-do-sec-css.css';
import '@css/careers-page-css.css';
import '@css/case-studies-css.css';
import '@css/center-content-sec-css.css';
import '@css/changemaker-hubs-css.css';
import '@css/communityimpact-css.css';
import '@css/comprehensive-school-partnerships.css';
import '@css/contact-us-page.css';
import '@css/csp-page-css.css';
import '@css/dana-page-css.css';
import '@css/decimal-list-sec-css.css';
import '@css/donate-today-css.css';
import '@css/donatenow-sec-css.css';
import '@css/donation-page-css.css';
import '@css/donation-thankyou.css';
import '@css/donors-page-css.css';
import '@css/faq-accordian-css.css';
import '@css/getinvolved-page-css.css';
import '@css/global-competence-page-css.css';
import '@css/global-green-sec-css.css';
import '@css/home-hero-css.css';
import '@css/home-map-sec-css.css';
import '@css/icons-blue-row-content-css.css';
import '@css/image-radius-col-css.css';
import '@css/index-css.css';
import '@css/inner-hero-css.css';
import '@css/latest-blog-css.css';
import '@css/leading-for-global-competence.css';
import '@css/left-right-pattern-image.css';
import '@css/our-approach-page-css.css';
import '@css/our-impact-page-css.css';
import '@css/our-work-page-css.css';
import '@css/partners-sec-css.css';
import '@css/profile-page-css.css';
import '@css/reports-page-css.css';
import '@css/team-page-css.css';
import '@css/testimonial-slider-css.css';
import '@css/video-center-sec-css.css';
import '@css/wemust-sec-css.css';
import BasicImage from 'components/Builder/BasicImage/BasicImage';
import BasicText from 'components/Builder/BasicText/BasicText';
import BasicTextWithImage from 'components/Builder/BasicTextWithImage/BasicTextWithImage';
import CaseStudy from 'components/Builder/CaseStudy/CaseStudy';

const Universalnew = ({ data }) => {
  console.log('data:', data);
  const { generalwrapper } = data?.wpPage?.ACFgeneralBuilder;
  const { title, metaDesc } = data?.wpPage?.seo;

  return (
    <div className='canvas'>
      <Layout>
        <Seo title={title} metaDesc={metaDesc} />
        {generalwrapper?.map((wrap, index) => {
          switch (wrap.fieldGroupName) {
            case 'Page_Acfgeneralbuilder_Generalwrapper_Secondgroup':
              console.log('Secondgroup', wrap.fieldGroupName);
              return wrap.wrapper110.map((section, index) => {
                switch (section.fieldGroupName) {
                  case 'Page_Acfgeneralbuilder_Generalwrapper_Secondgroup_Wrapper110_Hero1110':
                    console.log('Hero1111', section.fieldGroupName);
                    return <Hero1 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_Secondgroup_Wrapper110_Hero2':
                    return <Hero2 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_Secondgroup_Wrapper110_Hero3':
                    return <Hero3 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_Secondgroup_Wrapper110_HeroThanks':
                    return <HeroThanks key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_Secondgroup_Wrapper110_Map':
                    return <Map key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_Secondgroup_Wrapper110_Video1':
                    return <Video1 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_Secondgroup_Wrapper110_Video2':
                    return <Video2 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_Secondgroup_Wrapper110_Video3':
                    return <Video3 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_Secondgroup_Wrapper110_Video4':
                    return <Video4 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_Secondgroup_Wrapper110_HeroHome':
                    return (
                      <Page_Acfbuilder_Wrapper_HeroHome key={index} data={section} />
                    );
                  default:
                    return <React.Fragment key={index}></React.Fragment>;
                }
              })

            case 'Page_Acfgeneralbuilder_Generalwrapper_FirstGroup':
              return wrap.wrapper1120?.map((section, index) => {
                switch (section.fieldGroupName) {
                  case 'Page_Acfgeneralbuilder_Generalwrapper_FirstGroup_Wrapper1120_Content1':
                    return (
                      <Page_Acfbuilder_Wrapper_Content1 key={index} data={section} />
                    );
                  case 'Page_Acfgeneralbuilder_Generalwrapper_FirstGroup_Wrapper1120_Content2':
                    return <Content2 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_FirstGroup_Wrapper1120_Content3':
                    return <Content3 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_FirstGroup_Wrapper1120_Content4':
                    return <Content4 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_FirstGroup_Wrapper1120_Content5':
                    return <Content5 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_FirstGroup_Wrapper1120_Content6':
                    return <Content6 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_FirstGroup_Wrapper1120_Content7':
                    return <Content7 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_FirstGroup_Wrapper1120_Content8':
                    return <Content8 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_FirstGroup_Wrapper1120_Content9':
                    return <Content9 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_FirstGroup_Wrapper1120_Content10':
                    return <Content10 key={index} data={section} />;
                  default:
                    return <React.Fragment key={index}></React.Fragment>;
                }
              })
            case 'Page_Acfgeneralbuilder_Generalwrapper_ThirdGroup':
              return wrap.wrapper2130?.map((section, index) => {
                switch (section.fieldGroupName) {
                  case 'Page_Acfgeneralbuilder_Generalwrapper_ThirdGroup_Wrapper2130_Content11':
                    return <Content11 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_ThirdGroup_Wrapper2130_Content12':
                    return <Content12 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_ThirdGroup_Wrapper2130_Content13':
                    return <Content13 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_ThirdGroup_Wrapper2130_Content14':
                    return <Content14 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_ThirdGroup_Wrapper2130_Content15':
                    return <Content15 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_ThirdGroup_Wrapper2130_Content16':
                    return <Content16 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_ThirdGroup_Wrapper2130_Content17':
                    return <Content17 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_ThirdGroup_Wrapper2130_Content18':
                    return <Content18 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_ThirdGroup_Wrapper2130_Content19':
                    return <Content19 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_ThirdGroup_Wrapper2130_Content20':
                    return (
                      <Page_Acfbuilder_Wrapper_Content20 key={index} data={section} />
                    );
                  case 'Page_Acfgeneralbuilder_Generalwrapper_ThirdGroup_Wrapper2130_Content21':
                    return <Content21 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_ThirdGroup_Wrapper2130_Content22':
                    return <Content22 key={index} data={section} />;
                  default:
                    return <React.Fragment key={index}></React.Fragment>;
                }
              })
            case 'Page_Acfgeneralbuilder_Generalwrapper_FourthGroup':
              return wrap.wrapper3140?.map((section, index) => {
                switch (section.fieldGroupName) {
                  case 'Page_Acfgeneralbuilder_Generalwrapper_FourthGroup_Wrapper3140_ContentBlocks1':
                    return <ContentBlocks1 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_FourthGroup_Wrapper3140_ContentBlocks2':
                    return <ContentBlocks2 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_FourthGroup_Wrapper3140_ContentBlocks3':
                    return <ContentBlocks3 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_FourthGroup_Wrapper3140_ContentBlocks4':
                    return <ContentBlocks4 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_FourthGroup_Wrapper3140_ContentBlocks5':
                    return <ContentBlocks5 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_FourthGroup_Wrapper3140_ContentBlocks6':
                    return <ContentBlocks6 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_FourthGroup_Wrapper3140_ContentBlocks7':
                    return <ContentBlocks7 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_FourthGroup_Wrapper3140_ContentBlocks8':
                    return <ContentBlocks8 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_FourthGroup_Wrapper3140_ContentBlocks9':
                    return <ContentBlocks9 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_FourthGroup_Wrapper3140_ContentBlocks10':
                    return <ContentBlocks10 key={index} data={section} />;
                  default:
                    return <React.Fragment key={index}></React.Fragment>;
                }
              })
            case 'Page_Acfgeneralbuilder_Generalwrapper_SixthGroup':
              return wrap.wrapper5160?.map((section, index) => {
                switch (section.fieldGroupName) {
                  case 'Page_Acfgeneralbuilder_Generalwrapper_SixthGroup_Wrapper5160_ContentCards1':
                    return <ContentCards1 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_SixthGroup_Wrapper5160_ContentCards2':
                    return <ContentCards2 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_SixthGroup_Wrapper5160_ContentCards3':
                    return <ContentCards3 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_SixthGroup_Wrapper5160_ContentCards4':
                    return <ContentCards4 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_SixthGroup_Wrapper5160_ContentCards5':
                    return <ContentCards5 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_SixthGroup_Wrapper5160_ContentCards6':
                    return <ContentCards6 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_SixthGroup_Wrapper5160_ContentList1':
                    return <ContentList1 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_SixthGroup_Wrapper5160_ContentList2':
                    return <ContentList2 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_SixthGroup_Wrapper5160_ContentList3':
                    return <ContentList3 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_SixthGroup_Wrapper5160_ContentList4':
                    return <ContentList4 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_SixthGroup_Wrapper5160_ContentList5':
                    return <ContentList5 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_SixthGroup_Wrapper5160_ContentList6':
                    return <ContentList6 key={index} data={section} />;
                  default:
                    return <React.Fragment key={index}></React.Fragment>;
                }
              })
            case 'Page_Acfgeneralbuilder_Generalwrapper_SeventhGroup':
              return wrap.wrapper6170?.map((section, index) => {
                switch (section.fieldGroupName) {
                  case 'Page_Acfgeneralbuilder_Generalwrapper_SeventhGroup_Wrapper6170_DonationForm':
                    return <DonationForm key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_SeventhGroup_Wrapper6170_Donation1':
                    return <Donation1 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_SeventhGroup_Wrapper6170_Donation2':
                    return <Donation2 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_SeventhGroup_Wrapper6170_Donation3':
                    return <Donation3 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_SeventhGroup_Wrapper6170_Donation4':
                    return <Donation4 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_SeventhGroup_Wrapper6170_Slider1':
                    return <Slider1 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_SeventhGroup_Wrapper6170_Slider2':
                    return <Slider2 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_SeventhGroup_Wrapper6170_Slider3':
                    return <Slider3 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_SeventhGroup_Wrapper6170_Slider4':
                    return <Slider4 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_SeventhGroup_Wrapper6170_Slider5':
                    return <Slider5 key={index} data={section} />;
                  default:
                    return <React.Fragment key={index}></React.Fragment>;
                }
              })
            case 'Page_Acfgeneralbuilder_Generalwrapper_EighthGroup':
              return wrap.wrapper7180?.map((section, index) => {
                switch (section.fieldGroupName) {
                  case 'Page_Acfgeneralbuilder_Generalwrapper_EighthGroup_Wrapper7180_ConnectForm1':
                    return <ConnectForm1 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_EighthGroup_Wrapper7180_ConnectForm2':
                    return <ConnectForm2 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_EighthGroup_Wrapper7180_Highlight1':
                    return <Highlight1 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_EighthGroup_Wrapper7180_Highlight2':
                    return <Highlight2 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_EighthGroup_Wrapper7180_Highlight3':
                    return <Highlight3 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_EighthGroup_Wrapper7180_Highlight4':
                    return <Highlight4 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_EighthGroup_Wrapper7180_Highlight5':
                    return <Highlight5 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_EighthGroup_Wrapper7180_Highlight6':
                    return <Highlight6 key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_EighthGroup_Wrapper7180_MoreHighlight':
                    return <MoreHighlight key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_EighthGroup_Wrapper7180_Approach':
                    return <Approach key={index} data={section} />;
                  default:
                    return <React.Fragment key={index}></React.Fragment>;
                }
              })
            case 'Page_Acfgeneralbuilder_Generalwrapper_NinthGroup':
              return wrap.wrapper8190?.map((section, index) => {
                switch (section.fieldGroupName) {
                  case 'Page_Acfgeneralbuilder_Generalwrapper_NinthGroup_Wrapper8190_Book':
                    return <Book key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_NinthGroup_Wrapper8190_Events':
                    return <Events key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_NinthGroup_Wrapper8190_Contact':
                    return <Contact key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_NinthGroup_Wrapper8190_CaseStudies':
                    return <CaseStudy key={index} data={section} />;  
                  case 'Page_Acfgeneralbuilder_Generalwrapper_NinthGroup_Wrapper8190_ExecutiveTeam':
                    return <ExecutiveTeam key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_NinthGroup_Wrapper8190_StaffTeam':
                    return <StaffTeam key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_NinthGroup_Wrapper8190_Directors':
                    return <Directors key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_NinthGroup_Wrapper8190_DonorsList':
                    return <DonorsList key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_NinthGroup_Wrapper8190_Faq':
                    return <Faq key={index} data={section} />;
                  default:
                    return <React.Fragment key={index}></React.Fragment>;
                }
              })
            case 'Page_Acfgeneralbuilder_Generalwrapper_TenthGroup':
              return wrap.wrapper91100?.map((section, index) => {
                switch (section.fieldGroupName) {
                  case 'Page_Acfgeneralbuilder_Generalwrapper_TenthGroup_Wrapper91100_Imagine':
                    return <Imagine key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_TenthGroup_Wrapper91100_Header':
                    return <Header key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_TenthGroup_Wrapper91100_PartnersLogos':
                    return <PartnersLogos key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_TenthGroup_Wrapper91100_Positions':
                    return <Positions key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_TenthGroup_Wrapper91100_NewsWidget':
                    return <NewsWidget key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_TenthGroup_Wrapper91100_Reports':
                    return <Reports key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_TenthGroup_Wrapper91100_Topics':
                    return <Topics key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_TenthGroup_Wrapper91100_ThankYou':
                    return <ThankYou key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_TenthGroup_Wrapper91100_Image':
                    return <BasicImage key={index} data={section} />;
                  case 'Page_Acfgeneralbuilder_Generalwrapper_TenthGroup_Wrapper91100_Text':
                     return <BasicText key={index} data={section} />;   
                  case 'Page_Acfgeneralbuilder_Generalwrapper_TenthGroup_Wrapper91100_TextWithImage':
                     return <BasicTextWithImage key={index} data={section} />;   
                  default:
                    return <React.Fragment key={index}></React.Fragment>;
                }
              })
            default:
              return <React.Fragment key={index}></React.Fragment>;
          }
        })}        
      </Layout>
    </div>
  );
};

export default Universalnew;

export const pageQuery = graphql`
  query PageById($id: String!) {
    wpPage(id: { eq: $id }) {
      seo {
        metaDesc
        title
      }
      ACFgeneralBuilder {
        generalwrapper{
          ... on WpPage_Acfgeneralbuilder_Generalwrapper_FirstGroup {
            fieldGroupName
            wrapper1120 {
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_FirstGroup_Wrapper1120_Content1 {
                content1ButtonText
                content1Text
                content1ButtonExternalLink
                content1ButtonLink {
                  ... on WpPage {
                    id
                    uri
                  }
                  ... on WpEvent {
                    id
                    uri
                  }
                  ... on WpReport {
                    id
                    uri
                  }
                }
                fieldGroupName
                content1Title
                content1Image {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                }
                content1Logo {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_FirstGroup_Wrapper1120_Content2 {
                content2BackgroundColor
                content2ButtonEmailLink
                content2ColumnRatio                
                content2ButtonExternalLink
                content2ButtonInternalLink {
                  ... on WpPage {
                    id
                    uri
                  }
                  ... on WpEvent {
                    id
                    uri
                  }
                  ... on WpReport {
                    id
                    uri
                  }
                }
                content2ButtonText
                content2ButtonType
                content2Pattern
                content2Text
                content2Title
                fieldGroupName
                content2Image {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_FirstGroup_Wrapper1120_Content3 {
                content3BackgroundColor
                content3ButtonText
                content3ButtonExternalLink
                content3ButtonLink {
                  ... on WpPage {
                    id
                    uri
                  }
                }
                content3Pattern
                content3Text
                content3Title
                fieldGroupName
                content3Image {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_FirstGroup_Wrapper1120_Content4 {
                content4ButtonEmailLink
                content4ButtonText
                fieldGroupName
                content4Title
                content4Text
                content4ButtonExternalLink
                content4ButtonType
                content4ButtonPageLink {
                  ... on WpPage {
                    id
                    uri
                  }
                }
                content4Image {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_FirstGroup_Wrapper1120_Content5 {
                content5FirstButtonEmailLink
                content5ReverseRow
                content5FirstButtonText
                content5FirstButtonColor
                content5FirstButtonExternalLink
                content5SecondButtonExternalLink
                content5FirstButtonInternalLink {
                  ... on WpPage {
                    id
                    uri
                  }
                }
                content5FirstButtonType
                fieldGroupName
                content5Title
                content5Text
                content5Subtitile
                content5SecondButtonText
                content5BackgroundColor
                content5SecondButtonLink {
                  ... on WpPage {
                    id
                    uri
                  }
                }
                content5Image {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_FirstGroup_Wrapper1120_Content6 {
                content6ButtonText
                content6Text
                content6ButtonExternalLink
                content6ButtonLink {
                  ... on WpPage {
                    id
                    uri
                  }
                }
                content6Title
                fieldGroupName
                content6Image {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_FirstGroup_Wrapper1120_Content7 {
                content7LeftButtonText
                content7RightButtonLink
                content7LeftButtonExternalLink
                content7RightButtonExternalLink
                content7LeftButtonLink {
                  ... on WpPage {
                    id
                    uri
                  }
                }
                content7RightButtonText
                content7Text
                content7Title
                content7VideoUrl
                fieldGroupName
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_FirstGroup_Wrapper1120_Content8 {
                content8ButtonText
                content8Text
                fieldGroupName
                content8ButtonExternalLink
                content8VideoUrl
                content8Title
                content8ButtonLink {
                  ... on WpPage {
                    id
                    uri
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_FirstGroup_Wrapper1120_Content9 {
                content9ButtonText
                content9LeftText
                fieldGroupName
                content9ExternalButtonLink
                content9Title
                content9RightText
                content9ButtonLink {
                  ... on WpPage {
                    id
                    uri
                  }
                }
                content9LeftImage {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                }
                content9RightImage {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_FirstGroup_Wrapper1120_Content10 {
                content10ButtonLink
                content10ButtonText
                fieldGroupName                
                content10ButtonExternalLink
                content10Title
                content10LeftText
                content10RightText
              }  
            }
          }
          ... on WpPage_Acfgeneralbuilder_Generalwrapper_Secondgroup {
            componentTitle
            fieldGroupName
            wrapper110 {
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_Secondgroup_Wrapper110_HeroHome {
                fieldGroupName
                heroHomeButtonText
                heroHomeButtonExternalLink
                heroHomeButtonLink {
                  ... on WpPost {
                    id
                    uri
                  }
                  ... on WpPage {
                    id
                    uri
                  }
                  ... on WpEvent {
                    id
                    uri
                  }
                  ... on WpReport {
                    id
                    uri
                  }
                }
                heroHomeImage {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                }
                heroHomeSubtitle
                heroHomeTitle
                heroHomeVideo {
                  localFile {
                    publicURL
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_Secondgroup_Wrapper110_Hero1110 {
                buttonText
                fieldGroupName
                hero1ButtonExternalLink
                hero1ButtonLink {
                  ... on WpPage {
                    id
                    uri
                  }
                  ... on WpEvent {
                    id
                    uri
                  }
                  ... on WpReport {
                    id
                    uri
                  }
                }
                hero1DesktopImage {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                }
                hero1MobileImage {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                }
                hero1Text
                hero1Title110
                hero1GradientOverlay
                hero1NumberOfColumns
                hero1BackgroundPosition
                hero1Video {
                  localFile {
                    publicURL
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_Secondgroup_Wrapper110_Hero2 {
                fieldGroupName
                hero2Text
                hero2Title
                hero2DesktopImage {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                }
                hero2MobileImage {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                }
                hero2Video {
                  localFile {
                    publicURL
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_Secondgroup_Wrapper110_Hero3 {
                fieldGroupName
                hero3Text
                hero3Title
                hero3Image {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_Secondgroup_Wrapper110_HeroThanks {
                fieldGroupName
                heroThanksSubtitle
                heroThanksTitle
                heroThanksDesktopImage {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                }
                heroThanksMobileImage {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_Secondgroup_Wrapper110_Map {
                fieldGroupName
                mapButtonText
                mapCountries
                mapStates
                mapStudents
                mapSubtitle
                mapExternalLink
                mapTeachers
                mapTitle
                mapButtonLink {
                  ... on WpPage {
                    id
                    uri
                  }
                  ... on WpEvent {
                    id
                    uri
                  }
                  ... on WpReport {
                    id
                    uri
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_Secondgroup_Wrapper110_Video1 {
                fieldGroupName
                video1Text
                video1Title
                video1Url
                video1TopPadding
                video1BackgroundColor
                video1Icon {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_Secondgroup_Wrapper110_Video2 {
                fieldGroupName
                video2ButtonText
                video2ButtonExternalLink
                video2ButtonLink {
                  ... on WpPage {
                    id
                    uri
                  }
                }
                video2Url
                video2Title
                video2ShowMap
                video2Icon {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_Secondgroup_Wrapper110_Video3 {
                fieldGroupName
                video3ButtonEmail
                video3ButtonText
                video3Text
                video3BottomText
                video3Title
                video3ReverseRow
                video3Url
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_Secondgroup_Wrapper110_Video4 {
                fieldGroupName
                video4Title
                video4Url
                video4Icon {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                  }
                }
              }  
            }
          }
          ... on WpPage_Acfgeneralbuilder_Generalwrapper_ThirdGroup {
            fieldGroupName
            wrapper2130 {
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_ThirdGroup_Wrapper2130_Content11 {
                content11List
                content11Text
                content11Title
                fieldGroupName
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_ThirdGroup_Wrapper2130_Content12 {
                content12LeftList
                content12RightList
                content12Text
                content12Title
                fieldGroupName
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_ThirdGroup_Wrapper2130_Content13 {
                content13Header
                content13LeftButtonText
                content13LeftButtonExternalLink
                content13RightButtonExternalLink
                content13LeftButtonLink {
                  ... on WpPage {
                    id
                    uri
                  }
                }
                fieldGroupName
                content13Title
                content13Text
                content13RightButtonText
                content13RightButtonLink {
                  ... on WpPage {
                    id
                    uri
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_ThirdGroup_Wrapper2130_Content14 {
                content14ButtonLink
                content14ButtonText
                content14ButtonExternalLink
                content14Text
                content14Title
                fieldGroupName
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_ThirdGroup_Wrapper2130_Content15 {
                content15BottomText
                content15ButtonText
                content15ButtonExternalLink
                content15ButtonLink {
                  ... on WpPage {
                    id
                    uri
                  }
                }
                content15FeaturesList
                content15FeaturesTitle
                content15Subtitle
                content15Text
                content15Title
                content15ShowBottomBorder
                fieldGroupName
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_ThirdGroup_Wrapper2130_Content16 {
                content16Text
                content16Title
                fieldGroupName
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_ThirdGroup_Wrapper2130_Content17 {
                content17Subtitle
                content17Title
                fieldGroupName
                content17Blocks {
                  content17BlockText
                  content17BlockTitle
                }
                content17Image {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_ThirdGroup_Wrapper2130_Content18 {
                content18Text
                content18Title
                fieldGroupName
                content18Image {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_ThirdGroup_Wrapper2130_Content19 {
                content19Text
                content19Title
                fieldGroupName
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_ThirdGroup_Wrapper2130_Content20 {
                content20ButtonText
                content20LeftText
                content20AdditionalTopMargin
                content20ButtonExternalLink
                content20BackgroundColor
                content20ButtonLink {
                  ... on WpPage {
                    id
                    uri
                  }
                  ... on WpEvent {
                    id
                    uri
                  }
                  ... on WpReport {
                    id
                    uri
                  }
                }
                fieldGroupName
                content20Title
                content20RightText
                content20Icon {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_ThirdGroup_Wrapper2130_Content21 {
                content21Text
                content21Title
                fieldGroupName
                content21Image {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_ThirdGroup_Wrapper2130_Content22 {
                content22ButtonLink
                content22ButtonText
                content22Text
                content22Title
                content22ButtonExternalLink
                fieldGroupName
                content22Image {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                  }
                }
              }
            }
          }
          ... on WpPage_Acfgeneralbuilder_Generalwrapper_FourthGroup {
            componentTitle
            fieldGroupName
            wrapper3140 {
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_FourthGroup_Wrapper3140_ContentBlocks1 {
                contentBlocks1Block1Text
                contentBlocks1Block1Title
                fieldGroupName
                contentBlocks1Block2Title
                contentBlocks1Block2Text
                contentBlocks1Block1Icon {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                }
                contentBlocks1Block2Icon {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_FourthGroup_Wrapper3140_ContentBlocks2 {
                contentBlocks2Block1ButtonText
                contentBlocks2Block1Subtitle                
                contentBlocks2Block1ButtonExternalLink
                contentBlocks2Block2ButtonExternalLink
                contentBlocks2Block3ButtonExternalLink
                contentBlocks2Block1ButtonLink {
                  ... on WpPage {
                    id
                    uri
                  }
                  ... on WpPost {
                    id
                    uri
                  }
                  ... on WpEvent {
                    id
                    uri
                  }
                  ... on WpReport {
                    id
                    uri
                  }
                }
                contentBlocks2Block1Text
                contentBlocks2Block1Title
                contentBlocks2Block2ButtonLink {
                  ... on WpPage {
                    id
                    uri
                  }
                  ... on WpPost {
                    id
                    uri
                  }
                  ... on WpEvent {
                    id
                    uri
                  }
                  ... on WpReport {
                    id
                    uri
                  }
                }
                contentBlocks2Block2ButtonText
                contentBlocks2Block2Text
                contentBlocks2Block2Title
                contentBlocks2Block3ButtonLink {
                  url
                  target
                  title
                }
                contentBlocks2Block3ButtonText
                contentBlocks2Block3Text
                contentBlocks2Block3Title
                contentBlocks2Block4Text
                contentBlocks2Block4Title
                contentBlocks2Text
                contentBlocks2Title
                fieldGroupName
                contentBlocks2Blocks {
                  contentBlocks2BlockText
                  contentBlocks2BlockTitle
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_FourthGroup_Wrapper3140_ContentBlocks3 {
                contentBlocks3BottomText
                contentBlocks3Text
                fieldGroupName
                contentBlocks3Title
                contentBlocks3Blocks {
                  contentBlocks3BlockText
                  contentBlocks3BlockTitle
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_FourthGroup_Wrapper3140_ContentBlocks4 {
                contentBlocks4Title
                contentBlocks4BackgroundColor
                fieldGroupName 
                contentBlocks4Blocks {
                  contentBlocks4BlockTitle
                  contentBlocks4BlockText
                  contentBlocks4BlockImage {
                    localFile {
                      childImageSharp {
                        gatsbyImageData
                      }
                      publicURL
                    }
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_FourthGroup_Wrapper3140_ContentBlocks5 {
                contentBlocks5Subtitle
                contentBlocks5Title
                fieldGroupName
                contentBlocks5Blocks {
                  contentBlocks5BlockTitle
                  contentBlocks5BlockImage {
                    localFile {
                      childImageSharp {
                        gatsbyImageData
                      }
                      publicURL
                    }
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_FourthGroup_Wrapper3140_ContentBlocks6 {
                contentBlocks6Title
                fieldGroupName
                contentBlocks6Blocks {
                  contentBlocks6BlockText
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_FourthGroup_Wrapper3140_ContentBlocks7 {
                contentBlocks7Subtitle
                contentBlocks7Title
                fieldGroupName
                contentBlocks7Blocks {
                  contentBlocks7BlockTitle
                  contentBlocks7BlockText
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_FourthGroup_Wrapper3140_ContentBlocks8 {
                contentBlocks8Block1Text
                contentBlocks8Block1Title
                contentBlocks8Block2SmallText
                contentBlocks8Block2Text
                contentBlocks8Block2Title
                contentBlocks8Block3Text
                contentBlocks8Block3Title
                contentBlocks8Block4Text
                contentBlocks8Block4Title
                contentBlocks8Subtitle
                contentBlocks8Title
                fieldGroupName
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_FourthGroup_Wrapper3140_ContentBlocks9 {
                contentBlocks9Subtitle
                contentBlocks9Title
                fieldGroupName
                contentBlocks9Blocks {
                  contentBlocks9BlockTitle
                  contentBlocks9BlockText
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_FourthGroup_Wrapper3140_ContentBlocks10 {
                contentBlocks10Authot
                contentBlocks10ButtonText
                contentBlocks10BlockWidth
                contentBlocks10ButtonExternalLinks
                contentBlocks10ButtonLink {
                  ... on WpPage {
                    id
                    uri
                  }
                }
                contentBlocks10Blocks {
                  contentBlocks10BlockText
                  contentBlocks10BlockTitle
                }
                contentBlocks10Color
                contentBlocks10Image {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                }
                contentBlocks10Quote
                contentBlocks10Text
                contentBlocks10Title
                fieldGroupName
              }
            }
          }
          ... on WpPage_Acfgeneralbuilder_Generalwrapper_SixthGroup {
            componentTitle
            fieldGroupName
            wrapper5160 {
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_SixthGroup_Wrapper5160_ContentCards1 {
                contentCards1ButtonText
                contentCards1Text
                contentCards1BackgroundColor
                contentCards1ButtonExternalLink
                contentCards1ButtonLink {
                  ... on WpPage {
                    id
                    uri
                  }
                }
                contentCards1Cards {
                  contentCards1CardButtonLink {
                    ... on WpPage {
                      id
                      uri
                    }
                  }
                  contentCards1CardButtonExternalLink
                  contentCards1CardButtonText
                  contentCards1CardImage {
                    localFile {
                      childImageSharp {
                        gatsbyImageData
                      }
                      publicURL
                    }
                  }
                  contentCards1CardText
                  contentCards1CardTitle
                }
                contentCards1Title
                fieldGroupName
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_SixthGroup_Wrapper5160_ContentCards2 {
                contentCards2ButtonText
                contentCards2ButtonExternalLinkButtonExternalLink
                contentCards2Text
                contentCards2ButtonLink {
                  ... on WpPage {
                    id
                    uri
                  }
                }
                contentCards2Cards {
                  contentCards2CardText
                  contentCards2CardTitle
                }
                contentCards2Title
                fieldGroupName
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_SixthGroup_Wrapper5160_ContentCards3 {
                contentCards3ButtonText
                contentCards3Subtitle
                contentCards3ButtonExternalLink
                contentBlocks3BlocksColor
                contentCards3TopPadding
                contentCards3BottomPadding
                contentCards3ButtonLink {
                  ... on WpPage {
                    id
                    uri
                  }
                  ... on WpEvent {
                    id
                    uri
                  }
                  ... on WpReport {
                    id
                    uri
                  }
                }
                contentCards3Cards {
                  contentCards3CardText
                  contentCards3CardTitle
                }
                contentCards3Title
                fieldGroupName
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_SixthGroup_Wrapper5160_ContentCards4 {
                contentCards4ButtonText
                contentCards4ShowMap
                contentCards4ButtonExternalLink
                contentCards4ButtonLink {
                  ... on WpPage {
                    id
                    uri
                  }
                  ... on WpEvent {
                    id
                    uri
                  }
                  ... on WpReport {
                    id
                    uri
                  }
                }
                contentCards4Cards {
                  contentCards4CardText
                  contentCards4CardTitle
                }
                contentCards4Text
                contentCards4Title
                fieldGroupName
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_SixthGroup_Wrapper5160_ContentCards5 {
                contentCards5ButtonLink
                contentCards5ShowTopIcon
                contentCards5ButtonText
                contentCards5ButtonExternalLinks
                contentCards5Text
                contentCards5Title
                fieldGroupName
                contentCards5Cards {
                  contentCards5CardButtonLink
                  contentCards5CardButtonText
                  contentCards5CardSubtitle
                  contentCards5CardText
                  contentCards5CardTitle
                  contentCards5CardIcon {
                    localFile {
                      childImageSharp {
                        gatsbyImageData
                      }
                      publicURL
                    }
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_SixthGroup_Wrapper5160_ContentCards6 {
                contentCards6Text
                contentCards6Title
                fieldGroupName
                contentCards6Cards {
                  contentCards6CardTitle
                  contentCards6CardText
                  contentCards6CardSubtitle
                  contentCards6CardIcon {
                    localFile {
                      childImageSharp {
                        gatsbyImageData
                      }
                    }
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_SixthGroup_Wrapper5160_ContentList1 {
                contentList1BottomText
                contentList1Subtitle
                contentList1Text
                contentList1Title
                fieldGroupName
                contentList1Image {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_SixthGroup_Wrapper5160_ContentList2 {
                contentList2BottomText
                contentList2ButtonText
                fieldGroupName
                contentList2TranslateText
                contentList2Block {
                  contentList2BlockText
                  contentList2BlockTitle
                  contentList2BlockImage {
                    localFile {
                      childImageSharp {
                        gatsbyImageData
                      }
                      publicURL
                    }
                  }
                }
                contentList2ButtonLink {
                  localFile {
                    publicURL
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_SixthGroup_Wrapper5160_ContentList3 {
                contentList3ButtonEmailLink
                contentList3ButtonExternalLink
                contentList3ButtonText
                contentList3Block {
                  contentList3BlockSubtitle
                  contentList3BlockText
                  contentList3BlockTitle
                  fieldGroupName
                  contentList3BlockImage {
                    localFile {
                      childImageSharp {
                        gatsbyImageData
                      }
                      publicURL
                    }
                  }
                }
                contentList3ButtonPageLink {
                  ... on WpPage {
                    id
                    uri
                  }
                  ... on WpEvent {
                    id
                    uri
                  }
                  ... on WpReport {
                    id
                    uri
                  }
                }
                contentList3ButtonType
                contentList3Title
                fieldGroupName
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_SixthGroup_Wrapper5160_ContentList4 {
                contentList4Title
                fieldGroupName
                contentList4List {
                  contentList4ItemText
                  contentList4ItemTitle
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_SixthGroup_Wrapper5160_ContentList5 {
                contentList5BottomText
                contentList5Title
                fieldGroupName
                contentList5TopText
                contentList5List {
                  contentList5ItemText
                  contentList5ItemTitle
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_SixthGroup_Wrapper5160_ContentList6 {
                contentList6ButtonText
                contentList6ButtonExternalLink
                contentList6Subtitle
                contentList6PageLink {
                  ... on WpPage {
                    id
                    uri
                  }
                }
                contentList6Image {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                  }
                }
                contentList6Text
                contentList6Title
                fieldGroupName
              }
            }
          }
          ... on WpPage_Acfgeneralbuilder_Generalwrapper_SeventhGroup {
            componentTitle
            fieldGroupName
            wrapper6170 {
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_SeventhGroup_Wrapper6170_DonationForm {
                donationFormText
                fieldGroupName
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_SeventhGroup_Wrapper6170_Donation1 {
                donation1ButtonEmailLink
                donation1ButtonText
                donation1ButtonExternalLink
                donation1ButtonPageLink {
                  ... on WpPage {
                    id
                    uri
                  }
                  ... on WpEvent {
                    id
                    uri
                  }
                  ... on WpReport {
                    id
                    uri
                  }
                }
                donation1ButtonType
                donation1ButtonColor
                donation1Text
                fieldGroupName
                donation1Image {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_SeventhGroup_Wrapper6170_Donation2 {
                donation2ButtonText
                donation2ButtonExternalLink
                donation2Text
                donation2ButtonLink {
                  ... on WpPage {
                    id
                    uri
                  }
                  ... on WpEvent {
                    id
                    uri
                  }
                  ... on WpReport {
                    id
                    uri
                  }
                }
                donation2Image {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                }
                donation2Title
                fieldGroupName
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_SeventhGroup_Wrapper6170_Donation3 {
                donation3ButtonText
                donation3ButtonExternalLink
                donation3Text
                donation3ButtonLink {
                  ... on WpPage {
                    id
                    uri
                  }
                }
                donation3Title
                fieldGroupName
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_SeventhGroup_Wrapper6170_Donation4 {
                donation4ButtonText
                donation4ButtonExternalLink
                donation4Text
                donation4ButtonLink {
                  ... on WpPage {
                    id
                    uri
                  }
                }
                donation4Title
                fieldGroupName
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_SeventhGroup_Wrapper6170_Slider1 {
                fieldGroupName
                slider1Text
                slider1Slides {
                  slider1SlideText
                  slider1SlideTitle
                }
                slider1Title
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_SeventhGroup_Wrapper6170_Slider2 {
                fieldGroupName
                slider2Title
                slider2Slides {
                  slider1SlideSubtitle
                  slider1SlideText
                  slider1SlideTitle
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_SeventhGroup_Wrapper6170_Slider3 {
                fieldGroupName
                slider3Subtitle
                slider3Title
                slider3Slides {
                  slider3SlideText
                  slider3SlideTitle
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_SeventhGroup_Wrapper6170_Slider4 {
                fieldGroupName
                slider4Slides {
                  slider4SlideText
                  slider4SlideTitle
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_SeventhGroup_Wrapper6170_Slider5 {
                fieldGroupName
                slider5Subtitle
                slider5Title
                slider5BackgroundColor
                slider5Slides {
                  slider5SlideText
                  slider5SlideTitle
                }
              }
            }
          }
          ... on WpPage_Acfgeneralbuilder_Generalwrapper_EighthGroup {
            componentTitle
            fieldGroupName
            wrapper7180 {
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_EighthGroup_Wrapper7180_ConnectForm1 {
                connectForm1Subtitle
                connectForm1Title
                fieldGroupName
                connectForm1Image {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_EighthGroup_Wrapper7180_ConnectForm2 {
                connectForm2Subtitle
                connectForm2Title
                fieldGroupName
                connectForm2Image {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_EighthGroup_Wrapper7180_Highlight1 {
                fieldGroupName
                highlight1Title
                highlight1Image {
                  localFile {
                    publicURL
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_EighthGroup_Wrapper7180_Highlight2 {
                fieldGroupName
                highlight2ButtonEmailLink
                highlight2ButtonExternalLink
                highlight2ButtonPageLink {
                  ... on WpPage {
                    id
                    uri
                  }
                  ... on WpEvent {
                    id
                    uri
                  }
                  ... on WpReport {
                    id
                    uri
                  }
                }
                highlight2ButtonText
                highlight2ButtonType
                highlight2Text
                highlight2Title
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_EighthGroup_Wrapper7180_Highlight3 {
                fieldGroupName
                highlight3ButtonText
                highlight3BackgroundColor
                highlight3Title
                highlight3Text
                highlight3ButtonLink {
                  target
                  title
                  url
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_EighthGroup_Wrapper7180_Highlight4 {
                fieldGroupName
                highlight4ButtonText
                highlight4ButtonLink {
                  ... on WpPage {
                    id
                    uri
                  }
                }
                highlight4Text
                highlight4Title
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_EighthGroup_Wrapper7180_Highlight5 {
                fieldGroupName
                highlight5Text
                highlight5Title
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_EighthGroup_Wrapper7180_Highlight6 {
                fieldGroupName
                highlight6ButtonText
                highlight6ButtonExternalLink
                highlight6ButtonLink {
                  ... on WpPage {
                    id
                    uri
                  }
                }
                highlight6Text
                highlight6Title
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_EighthGroup_Wrapper7180_MoreHighlight {
                fieldGroupName
                moreHighlightButtonLink
                moreHighlightButtonExternalLink
                moreHighlightButtonText
                moreHighlightSubtitile
                moreHighlightText
                moreHighlightTitle
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_EighthGroup_Wrapper7180_Approach {
                approachLeftButtonText
                approachRightButtonText
                approachLeftButtonExternalLink
                approachRightButtonExternalLink
                approachLeftButtonLink {
                  ... on WpPage {
                    id
                    uri
                  }
                  ... on WpEvent {
                    id
                    uri
                  }
                  ... on WpReport {
                    id
                    uri
                  }
                }
                approachRightButtonLink {
                  ... on WpPage {
                    id
                    uri
                  }
                  ... on WpEvent {
                    id
                    uri
                  }
                  ... on WpReport {
                    id
                    uri
                  }
                }
                approachText
                approachTitle
                fieldGroupName
              }
            }
          }
          ... on WpPage_Acfgeneralbuilder_Generalwrapper_NinthGroup {
            componentTitle
            fieldGroupName
            wrapper8190 {
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_NinthGroup_Wrapper8190_Blog {
                fieldGroupName
                blogFeaturedPosts {
                  ... on WpPost {
                    id
                    uri
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_NinthGroup_Wrapper8190_Book {
                bookEmail
                bookEmailButtonText
                bookImage {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                }
                bookInstagramButtonText
                bookInstagramLink
                bookLinkedinButtonText
                bookLinkedinLink
                bookText
                bookTitle
                fieldGroupName
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_NinthGroup_Wrapper8190_Events {
                fieldGroupName
                blogFeaturedPosts {
                  ... on WpPost {
                    id
                    uri
                  }
                }
                eventsTitle
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_NinthGroup_Wrapper8190_Contact {
                contactEndText
                contactNumberTel
                contactBlocks {
                  contactBlockText
                  contactBlockTitle
                }
                contactNumberText
                contactStartText
                contactTitle
                fieldGroupName
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_NinthGroup_Wrapper8190_CaseStudies {
                caseStudiesTitle
                caseStudiesBlocks {
                  caseStudiesCaseStudyTitle
                  caseStudiesCaseStudyImage {
                    localFile {
                      childImageSharp {
                        gatsbyImageData
                      }
                    }
                  }
                  caseStudiesCaseStudyFile {
                    filename
                    publicUrl
                  }
                }                   
                fieldGroupName
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_NinthGroup_Wrapper8190_ExecutiveTeam {
                executiveTeamTitle
                fieldGroupName
                executiveTeamBlocks {
                  executiveTeamDesctiption
                  executiveTeamEmail
                  executiveTeamFacebookLink
                  executiveTeamLinkedinLink
                  executiveTeamName
                  executiveTeamPosition
                  executiveTeamPronounce
                  executiveTeamImage {
                    localFile {
                      childImageSharp {
                        gatsbyImageData
                      }
                      publicURL
                    }
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_NinthGroup_Wrapper8190_StaffTeam {
                fieldGroupName
                staffTeamTitle
                staffTeamBackgroundColor
                staffTeamBlocks {
                  staffTeamDescription
                  staffTeamEmail
                  staffTeamFacebookLink
                  staffTeamLinkedinLink
                  staffTeamName
                  staffTeamPosition
                  staffTeamPronounce
                  staffTeamImage {
                    localFile {
                      childImageSharp {
                        gatsbyImageData
                      }
                      publicURL
                    }
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_NinthGroup_Wrapper8190_Directors {
                directorsText
                directorsTitle
                directorsBackgroundColor
                directorsBlocks {
                  directorsDescription
                  directorsEmail
                  directorsFacebookLink
                  directorsLinkedinLink
                  directorsName
                  directorsPosition
                  directorsPronounce
                  directorsImage {
                    localFile {
                      childImageSharp {
                        gatsbyImageData
                      }
                      publicURL
                    }
                  }
                }
                fieldGroupName
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_NinthGroup_Wrapper8190_DonorsList {
                donorsListTitle
                fieldGroupName
                donorsListFirstImage {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                }
                donorsListFirstList {
                  donorsListFirstListName
                }
                donorsListSecondImage {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                }
                donorsListSecondList {
                  donorsListSecondListName
                }
                donorsListThirdList {
                  donorsListThirdListName
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_NinthGroup_Wrapper8190_Faq {
                faqContactEmail
                faqContactEmailText
                faqContactText
                faqTitle
                fieldGroupName
                faqFaqs {
                  faqAnswer
                  faqQuestion
                }
              }
            }
          }
          ... on WpPage_Acfgeneralbuilder_Generalwrapper_TenthGroup {
            componentTitle
            fieldGroupName
            wrapper91100 {
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_TenthGroup_Wrapper91100_Imagine {
                fieldGroupName
                imagineTitle
                imagineSlides {
                  imagineSlideText
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_TenthGroup_Wrapper91100_Header {
                fieldGroupName
                headerSubtitle
                headerTitle
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_TenthGroup_Wrapper91100_PartnersLogos {
                fieldGroupName
                partnersLogosSubtitle
                partnersLogosTitle
                partnersLogosLogos {
                  partnersLogosLogo {
                    localFile {
                      childImageSharp {
                        gatsbyImageData
                      }
                      publicURL
                    }
                  }
                  partnersLogosLogoLink
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_TenthGroup_Wrapper91100_Positions {
                fieldGroupName
                positionsTitle
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_TenthGroup_Wrapper91100_NewsWidget {
                fieldGroupName
                newsWidgetButtonExternalLink
                newsWidgetButtonText
                newsWidgetButtonLink {
                  ... on WpPage {
                    id
                    uri
                  }
                  ... on WpEvent {
                    id
                    uri
                  }
                  ... on WpReport {
                    id
                    uri
                  }
                }
                newsWidgetSubtitle
                newsWidgetTitle
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_TenthGroup_Wrapper91100_Reports {
                fieldGroupName
                reportsAnnualReportsBlocks {
                  reportsAnnualBlockButtonLink {
                    filename
                    uri
                  }
                  reportsAnnualBlockButtonText
                  reportsAnnualBlockTitle
                }
                reportsFinancialReportBlocks {
                  reportsFinancialBlockButtonText
                  reportsFinancialBlockTitle
                  reportsFinancialBlockButtonLink {
                    filename
                    uri
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_TenthGroup_Wrapper91100_Topics {
                fieldGroupName
                topicsTitle
                topicsBlocks {
                  topicsBlockBody
                  topicsBlockHeader
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_TenthGroup_Wrapper91100_ThankYou {
                fieldGroupName
                thankYouAddress
                thankYouContactText
                thankYouFacebookLink
                thankYouInstagramLink
                thankYouLinkedinLink
                thankYouText
                thankYouYoutubeLink
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_TenthGroup_Wrapper91100_Image {                
                fieldGroupName
                imageBackgroundColor
                imageImageLink
                imageImage {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                  }
                }
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_TenthGroup_Wrapper91100_Text {                
                fieldGroupName
                buttonLink {
                  ... on WpPage {
                    uri
                  }
                }
                textBackgroundColor
                textButtonExternalLink
                textButtonText
                textSubtitle
                textText
                textTitle
              }
              ... on WpPage_Acfgeneralbuilder_Generalwrapper_TenthGroup_Wrapper91100_TextWithImage {
                fieldGroupName
                textWithImageBackgroundColor
                textWithImageButtonExternalLink
                textWithImageButtonLink {
                  ... on WpPage {
                    uri
                  }
                }
                textWithImageButtonText
                textWithImageImage {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                  }
                }
                textWithImageImageLink
                textWithImageText
                textWithImageTitle
              }  
            }
          }      
        }
      }      
    }
  }
`;
